const classTool = {
  namespaced: true,
  state: {
    toolMap: [
      // 不确定枚举类是否一直会连续
      { index: 0, name: 'EClassroom' },
      { index: 1, name: 'QQ' },
      { index: 2, name: 'Skype' },
      { index: 3, name: 'FastMeeting' },
      { index: 4, name: 'OnlineClass' },
      { index: 5, name: 'AcadsocClass' },
      { index: 6, name: 'WeChat' },
      { index: 7, name: 'ClassIn' },
      { index: 8, name: 'AClassroom' },
      { index: 9, name: 'GameClass' },
      { index: 10, name: 'AcsPro+' },
      { index: 11, name: 'Tencent Classroom' }
    ]
  },
  actions: {
    callAclassRoom () {

    }
  },
  getters: {
    parse: (state) => (value) => {
      if (value !== undefined) {
        if (Number.isInteger(value)) {
          return state.toolMap.find(t => t.index === value)
        }
        if (value instanceof String) {
          return state.toolMap.find(t => value.toLowerCase().includes(t.name.toLowerCase()))
        }
        return null
      }
    }
  }
}
export default classTool
